import { render, staticRenderFns } from "./CallLogSummary.vue?vue&type=template&id=5d2cad22&scoped=true&"
import script from "./CallLogSummary.vue?vue&type=script&lang=js&"
export * from "./CallLogSummary.vue?vue&type=script&lang=js&"
import style0 from "./CallLogSummary.vue?vue&type=style&index=0&id=5d2cad22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2cad22",
  null
  
)

export default component.exports